import React from 'react';
import * as S from './details-section.styles';

const LoadingDetailsSection = () => {
  return (
    <S.ListWrap>
      <p className="dF alignItemsCenter marginB10">
        <span className="loadingShimmerSquare"></span>{' '}
        <span className="marginL10 loadingShimmer wid45"></span>
      </p>
      <div className="dF alignItemsCenter justifyBetween marginB15">
        <div className="wid70">
          <p className="marginB5 loadingShimmer wid33-3"></p>
          <p className="marginB5 loadingShimmer height18 wid70"></p>
        </div>
        <span className="pricing loadingShimmer"></span>
      </div>
      <p className="greyCnt dF">
        <span className="marginR7 dF alignItemsCenter wid40">
          {' '}
          <span className="loadingSmallSquare"></span>
          <span className="marginL10 loadingShimmer wid45"></span>
        </span>
        <span className="marginR7 dF alignItemsCenter wid40">
          <span className="loadingSmallSquare"></span>{' '}
          <span className="marginL10 loadingShimmer wid45"></span>
        </span>
      </p>
    </S.ListWrap>
  );
};
export default LoadingDetailsSection;
